<template>
    <div class="imprint">
        <section class="section page-wrapper">
            <div class="section__content">
                <h1 class="section__heading">
                    {{ $t('pages.imprint.heading') }}
                </h1>

                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.contact') }}</h3>
                    <div>
                        <p>{{ $t('pages.imprint.contact_text') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_text1') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_text2') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_text4') }}</p>

                        <p class="imprint__sweden-item">{{ $t('pages.imprint.contact_sweden_text') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_sweden_text1') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_sweden_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_sweden_text4') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.contact_sweden_text5') }}</p>
                    </div>
                </div>
                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.representatives') }}</h3>
                    <div>
                        <p>{{ $t('pages.imprint.representatives_text') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.representatives_text1') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.representatives_text2') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.representatives_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.representatives_text4') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.representatives_text5') }}</p>

                        <p class="imprint__sweden-item">{{ $t('pages.imprint.nordic_representatives_text') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.nordic_representatives_text1') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.nordic_representatives_text2') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.nordic_representatives_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.nordic_representatives_text4') }}</p>
                    </div>
                </div>
                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.register_entry') }}</h3>
                    <div>
                        <p class="imprint__item">{{ $t('pages.imprint.register_entry_text1') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.register_entry_text2') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.register_entry_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.register_entry_text4') }}</p>

                        <p class="imprint__sweden-item imprint__item">
                            {{ $t('pages.imprint.sweden_register_entry_text1') }}
                        </p>
                        <p class="imprint__item">{{ $t('pages.imprint.sweden_register_entry_text2') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.sweden_register_entry_text3') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.sweden_register_entry_text4') }}</p>
                        <p class="imprint__item">{{ $t('pages.imprint.sweden_register_entry_text5') }}</p>
                    </div>
                </div>
                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.disclaimer') }}</h3>
                    <div>
                        <p>{{ $t('pages.imprint.disclaimer_text1') }}</p>
                        <p>{{ $t('pages.imprint.disclaimer_text2') }}</p>
                        <p>{{ $t('pages.imprint.disclaimer_text3') }}</p>
                    </div>
                </div>
                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.liability') }}</h3>
                    <div>
                        <p>{{ $t('pages.imprint.liability_text1') }}</p>
                    </div>
                </div>
                <div class="imprint__section">
                    <h3>{{ $t('pages.imprint.copyrights') }}</h3>
                    <div>
                        <p>{{ $t('pages.imprint.copyrights_text1') }}</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="section__content wrap">
                <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
                <i18n path="pages.imprint.icons_copyright">
                    <template #eucalyp>
                        <a
                            rel="nofollow"
                            target="_blank"
                            href="https://www.flaticon.com/authors/eucalyp"
                            title="Eucalyp"
                        >
                            Eucalyp
                        </a>
                    </template>
                    <template #flaticon>
                        <a rel="nofollow" target="_blank" href="https://www.flaticon.com/" title="Flaticon">
                            www.flaticon.com
                        </a>
                    </template>
                    <template #cc>
                        <a
                            rel="nofollow"
                            href="http://creativecommons.org/licenses/by/3.0/"
                            title="Creative Commons BY 3.0"
                            target="_blank"
                        >
                            CC 3.0 BY
                        </a>
                    </template>
                </i18n>
                <!-- eslint-enable @intlify/vue-i18n/no-raw-text -->
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Imprint',
    head() {
        return {
            title: this.$t('pages.imprint.heading'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.imprint.seo_description'),
                },
            ],
        };
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';
.imprint {
    .section__content {
        max-width: 680px;
    }

    &__item {
        margin-bottom: 8px;
    }

    h3 {
        @extend %heading-3;
        margin-bottom: 24px;
    }

    &__section {
        margin-top: 40px;
    }

    &__sweden-item {
        margin-top: 32px;
    }
}
</style>
